import classes from "./MenuItem.module.css";

const MenuItem = (props) => {
  return (
    <div className={classes.menuItem} onClick={props.onClick}>
      <img src={props.image} alt="" />
      <div className={classes.menuItemOverlay}>
        <p className={classes.menuItemTitle}>{props.name}</p>
      </div>
    </div>
  );
};

export default MenuItem;
